export const isUrl = (path) => {
  return typeof path === 'string' && path.startsWith('http') && path.includes('.');
};
